import { request } from "@/interface/helper";

const str = "idoProject";

export const idoProject = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/ido/project/list" }),
    add: data => request({ data, method: "post", url: "/ido/project/add" }),
    detail: data => request({ data, method: "post", url: "/ido/project/detail" }),
    edit: data => request({ data, method: "post", url: "/ido/project/modify" })
  }
};
